"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = require("styled-components");

var _camelCase = _interopRequireDefault(require("../../helpers/camelCase"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function useLocalTheme(componentName, defaultTheme, localTheme) {
  var theme = (0, _styledComponents.useTheme)();
  var camelCaseComponentName = (0, _camelCase["default"])(componentName);
  if (localTheme) return localTheme;
  if (theme.localThemes && theme.localThemes[camelCaseComponentName]) return theme.localThemes[camelCaseComponentName];
  return defaultTheme(theme);
}

var _default = useLocalTheme;
exports["default"] = _default;
//# sourceMappingURL=useLocalTheme.js.map